type ChartElement = {
  order: number;
  [key: string]: any; // allow other fields too
};

export const orderChartElements = <T extends ChartElement>(items: T[], start: number = 0): T[] => {
  return items.map((item, index) => ({
    ...item,
    order: start + index
  }));
}